<template>
  <div class="AIDiagnosis">
    <div class="page_img">
      <img src="@/assets/img/ai_system.jpg" alt="">
    </div>
    <div class="page_content content flex_row">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="page_summary font_shadow">眼科AI辅助诊断/处方</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/ai_main.png" alt="">
      <div class="main_explain ai_explain">眼视光的医疗属性发展方向的大趋势下，在眼科医生紧缺的现状下, 唯有人工智能诊断分析可以帮助门诊门店成为跨入分级诊疗体系的桥梁</div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column system_title">
        <div class="sys_summary">眼健康领域的AI应用案例</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="system_main1">
        <img src="@/assets/img/ai_main1.png" alt="">
      </div>
    </div>
    <div class="container flex_row">
      <div class="container_item flex_row" v-for="item in containList">
        <img :src="item.img" alt="">
        <span>{{item.title}}</span>
      </div>
    </div>
    <div class="page_system flex_column system" v-for="items in list">
      <div class="sys_title flex_column system_title">
        <div class="sys_summary">{{items.summary}}</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="sys_main system_main flex_row" v-for="item in items.item">
        <div class="sys_left flex_row">
          <img :src="item.src" alt="">
        </div>
        <div class="sys_right system_right">
          <div class="title ai_title font_shadow">{{item.title}}</div>
          <div class="info ai_info">{{item.info}}</div>
          <div class="tag ai_tag" v-for="tag in item.tag"><span></span>{{tag}}</div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'AIDiagnosis',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
      list: [],
      containList: []
    }
  },
  created() {
    let list = [
      {
        summary: '眼健康中心的运营端人工智能',
        item: [
          {
            src: 'https://www.visumall.com/public/img/ai_content1.png',
            title: '人工智能诊断',
            info: 'VISUMALL-PACS系统智能分析患者的眼底相片，对眼底病变进行自动识别，从而判断顾客眼底是否正常',
          },
          {
            src: 'https://www.visumall.com/public/img/ai_content2.png',
            title: '人工智能处方',
            info: 'VISUMALL拥有百万级临床大数据的人工智能数字模型，从而可以在临床中通过问诊数据、屈光检查、眼健康检查和视功能分析等数',
          },
        ]
      },
      {
        summary: '眼视光中心的运营端智能流程体验',
        item: [
          {
            src: 'https://www.visumall.com/public/img/ai_content3.png',
            title: '智能诊断详解',
            info: '多病种智能诊断，轻松了解青光眼、糖尿病视网膜病变、老年黄斑变性等在内的常见二十余种眼底病变',
          },
          {
            src: 'https://www.visumall.com/public/img/ai_content4.png',
            title: '手动成像模拟',
            info: '大量的3D虚拟成像让学员可以自己组合各种光学成像，包括眼部结构的解剖和透镜的组合',
          },
        ]
      },
      {
        summary: '眼健康中心的运营端智能分析诊断',
        item: [
          {
            src: 'https://www.visumall.com/public/img/ai_content5.png',
            title: '视功能检查分析',
            info: 'VISUMALL平台通过患者顾客视功能数据AI智能计算并诊断分析给出结论，从而解决了门诊门店一直紧缺专业视光师难题',
          },
          {
            src: 'https://www.visumall.com/public/img/ai_content6.png',
            title: '视功能诊断处方',
            info: '系统为顾客患者开具AI智能处方，并且给出顾客患者最佳眼健康解决方案',
          }
        ]
      }
    ];
    let containList = [
      {
        img: 'https://www.visumall.com/public/img/ai_small1.png',
        title: '手术机器人'
      },
      {
        img: 'https://www.visumall.com/public/img/ai_small2.png',
        title: '流程助手'
      },
      {
        img: 'https://www.visumall.com/public/img/ai_small3.png',
        title: '护理辅助'
      },
      {
        img: 'https://www.visumall.com/public/img/ai_small4.png',
        title: '药物管理'
      },
      {
        img: 'https://www.visumall.com/public/img/ai_small5.png',
        title: '风险控制'
      },
      {
        img: 'https://www.visumall.com/public/img/ai_small6.png',
        title: '智能设备'
      },
      {
        img: 'https://www.visumall.com/public/img/ai_small7.png',
        title: '临床辅助'
      },
      {
        img: 'https://www.visumall.com/public/img/ai_small8.png',
        title: '辅助诊断'
      },
      {
        img: 'https://www.visumall.com/public/img/ai_small9.png',
        title: '影像诊断'
      },
      {
        img: 'https://www.visumall.com/public/img/ai_small10.png',
        title: '数据安全'
      },

    ];
    this.list = list;
    this.containList = containList;
  },
}
</script>

<style scoped lang="scss">
.AIDiagnosis {
  .content {
    margin: 0.4rem 0 0.6rem;
  }
  .main {
    margin-bottom: 1rem;
    img {
      width: 50%;
    }
    .ai_explain {
      margin: 0.5rem 0 0;
      width: 65%;
      padding: 0.25rem 0.45rem;
      font-size: 0.19rem;
      font-weight: 500;
    }
  }
  .container {
    margin-bottom: 1.3rem;
    flex-wrap: wrap;
    .container_item {
      width: 20%;
      flex-direction: column;
      margin-top: 0.55rem;
      img {
        width: 80%;
      }
      span {
        margin-top: 0.1rem;
        font-size: 0.22rem;
        font-weight: bold;
      }
    }
  }
  .system {
    margin-bottom: 1.3rem;
    .system_title {
      .sys_summary {
        text-align: center;
        font-size: 0.3rem;
        font-weight: bold;
      }
    }
    .system_main1 {
      margin-top: 0.8rem;
      img {
        width: 60%;
      }
    }
    .system_main {
      margin-top: 0.8rem;
      .sys_left {
        flex: 1;
        img {
          width: 60%;
        }
      }
      .system_right {
        flex: 1;
        margin-top: 0.2rem;
        .ai_title {
          font-weight: bold;
          font-size: 0.25rem;
        }
        .ai_info {
          width: 70%;
          margin-top: 0.22rem;
          font-size: 0.19rem;
        }
      }
    }
  }

}
</style>
